import { logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { analytics, initAnalytics, auth } from '../firebase';

// ✅ Admin email listesi
const ADMIN_EMAILS = ['info@tronapazarlama.com'];

// ✅ Admin kontrolü - LOG EKLE
const isAdminUser = () => {
  const user = auth.currentUser;
  console.log('🔍 isAdminUser kontrol:', {
    user: user?.email || 'NULL',
    isAdmin: user?.email ? ADMIN_EMAILS.includes(user.email.toLowerCase()) : false
  });
  
  if (!user?.email) return false;
  return ADMIN_EMAILS.includes(user.email.toLowerCase());
};

// Analytics hazır olana kadar bekle
const waitForAnalytics = async () => {
  console.log('🔍 waitForAnalytics çağrıldı');
  
  // ✅ Admin ise analytics'i başlatma
  if (isAdminUser()) {
    console.log('🔒 ADMIN TESPİT EDİLDİ - Analytics NULL döndürülüyor');
    return null;
  }

  // Zaten varsa direkt dön
  if (analytics) {
    console.log('✅ Analytics zaten mevcut');
    return analytics;
  }

  console.log('⏳ Analytics başlatılıyor...');
  // Yoksa başlat ve bekle
  const instance = await initAnalytics();
  if (!instance) {
    console.error('❌ Analytics başlatılamadı!');
    return null;
  }
  console.log('✅ Analytics başlatıldı');
  return instance;
};

// ✅ Sayfa görüntüleme
export const trackPageView = async (pagePath, pageTitle) => {
  console.log('═══════════════════════════════════');
  console.log('📍 trackPageView ÇAĞRILDI');
  console.log('Path:', pagePath || window.location.pathname);
  console.log('Title:', pageTitle || document.title);
  
  try {
    // ✅ Admin kontrolü
    if (isAdminUser()) {
      console.log('🔒 ADMIN - PAGE_VIEW ATLANDI');
      console.log('═══════════════════════════════════');
      return;
    }

    const analyticsInstance = await waitForAnalytics();
    if (!analyticsInstance) {
      console.log('⚠️ Analytics instance NULL - Event gönderilemedi');
      console.log('═══════════════════════════════════');
      return;
    }

    const eventParams = {
      page_path: pagePath || window.location.pathname,
      page_title: pageTitle || document.title,
      page_location: window.location.href
    };

    logEvent(analyticsInstance, 'page_view', eventParams);
    console.log('✅ PAGE_VIEW GÖNDERİLDİ:', eventParams.page_path);
    console.log('═══════════════════════════════════');
  } catch (error) {
    console.error('❌ trackPageView hatası:', error);
    console.log('═══════════════════════════════════');
  }
};

// ✅ User type ayarla
export const setUserType = async (user) => {
  console.log('═══════════════════════════════════');
  console.log('👤 setUserType ÇAĞRILDI');
  console.log('User:', user?.email || 'GUEST');
  
  try {
    // ✅ Admin kontrolü
    if (user?.email && ADMIN_EMAILS.includes(user.email.toLowerCase())) {
      console.log('🔒 ADMIN - USER_TYPE AYARLANMADI');
      console.log('═══════════════════════════════════');
      return;
    }

    const analyticsInstance = await waitForAnalytics();
    if (!analyticsInstance) {
      console.log('⚠️ Analytics instance NULL - User type ayarlanamadı');
      console.log('═══════════════════════════════════');
      return;
    }

    if (user) {
      setUserId(analyticsInstance, user.uid);
      setUserProperties(analyticsInstance, {
        user_type: 'registered',
        email_domain: user.email?.split('@')[1]
      });
      console.log('✅ USER_TYPE SET: registered -', user.email);
    } else {
      setUserId(analyticsInstance, null);
      setUserProperties(analyticsInstance, {
        user_type: 'guest'
      });
      console.log('✅ USER_TYPE SET: guest');
    }
    console.log('═══════════════════════════════════');
  } catch (error) {
    console.error('❌ setUserType hatası:', error);
    console.log('═══════════════════════════════════');
  }
};

// ✅ Custom event
export const trackEvent = async (eventName, params = {}) => {
  console.log('📊 trackEvent:', eventName, params);
  
  try {
    if (isAdminUser()) {
      console.log('🔒 ADMIN - EVENT ATLANDI:', eventName);
      return;
    }

    const analyticsInstance = await waitForAnalytics();
    if (!analyticsInstance) return;

    logEvent(analyticsInstance, eventName, params);
    console.log('✅ EVENT GÖNDERİLDİ:', eventName);
  } catch (error) {
    console.error('❌ trackEvent hatası:', error);
  }
};

// ✅ Buton tıklama
export const trackButtonClick = (buttonName, location) => {
  if (isAdminUser()) {
    console.log('🔒 ADMIN - BUTTON_CLICK ATLANDI:', buttonName);
    return;
  }
  trackEvent('button_click', {
    button_name: buttonName,
    location: location
  });
};

// ✅ Form gönderme
export const trackFormSubmit = (formName, success = true) => {
  if (isAdminUser()) {
    console.log('🔒 ADMIN - FORM_SUBMIT ATLANDI:', formName);
    return;
  }
  trackEvent('form_submit', {
    form_name: formName,
    success: success
  });
};

// ✅ Hata kaydet
export const trackError = async (description, fatal = false) => {
  try {
    if (isAdminUser()) {
      console.log('🔒 ADMIN - EXCEPTION LOCAL LOG:', description);
      return;
    }

    const analyticsInstance = await waitForAnalytics();
    if (!analyticsInstance) return;

    logEvent(analyticsInstance, 'exception', {
      description: description,
      fatal: fatal
    });
    console.log('⚠️ Exception logged:', description);
  } catch (error) {
    console.error('❌ Exception log hatası:', error);
  }
};